      <div class="coverflow reveal" data-coverflow tabindex="0"
           role="group" aria-roledescription="carousel"
           aria-label="Seçili işler" data-i18n-attr="aria-label:cf.label"{{{ root }}}>
        <div class="coverflow-stage">
          <ul class="coverflow-track" data-cf-track>
{{#each featured}}
        <li class="coverflow-item" role="group" aria-roledescription="slide" aria-label="{{ @n }} / {{ @count }}">
          <img data-full="{{ full }}" src="{{ browse }}"
               alt="{{ alt }}"
               width="{{ width }}" height="{{ height }}" loading="lazy" decoding="async">
        </li>
{{/each}}
          </ul>
        </div>

        <button class="coverflow-nav coverflow-nav--prev" type="button" data-cf-prev
                aria-label="Önceki kare" data-i18n-attr="aria-label:cf.prev"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>
        <button class="coverflow-nav coverflow-nav--next" type="button" data-cf-next
                aria-label="Sonraki kare" data-i18n-attr="aria-label:cf.next"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>

        <div class="coverflow-dots" data-cf-dots></div>
        <p class="visually-hidden" data-cf-live aria-live="polite"></p>
      </div>

{{#if more}}
      <div class="work-more reveal">
{{{ more }}}
      </div>
{{/if}}

      <!-- Ortadaki kareye tıklayınca açılan büyütme katmanı -->
      {{> lightbox }}
